export const PAYMENT_ALREADY_REGISTERED = "Payment already registered with this email";
export const PAYMENT_ERROR = "An error occurred while processing the payment. Please try again.";
export const PAYMENT_ERROR_INSUFFICIENT_BALANCE = "Insufficient $KOLZ balance.";
export const PAYMENT_ERROR_SWITCH_CHAIN = "There was an error switching the chain.";
export const PAYMENT_ERROR_REGISTRATION = "Error registering payment";
